import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Scrollbar from '../../components/scrollbar'
import { useParams } from 'react-router-dom'
import BlogSingle from '../../components/BlogDetails'
import Footer from '../../components/footer';
import Logo from '../../images/logo.svg'
import { fetchBlog } from '../../api/api';
import { useFetch } from '../../hooks/useFetch';
import { useTranslation } from 'react-i18next';


const BlogDetails = () => {

    const { id } = useParams()

    const { data: BlogDetails, isLoading, error } = useFetch(["blog", id], (lang) => fetchBlog(lang, id))


    const { t } = useTranslation();
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={BlogDetails?.data?.data?.title} pagesub={t('pageTitles.blogSub')} />
            <BlogSingle isLoading={isLoading} error={error} BlogDetails={BlogDetails} />
            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogDetails;
